<template>
  <div>
    <Header></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="padding-bottom: 30px">
      <div class="applyBody">
        <!--申请表提示-->
        <div class="applyTips">
          <router-link  to="/onload">已有账号，马上登陆 </router-link><a> | </a><router-link to="/"> 返回广东省仪器仪表学会网站</router-link>
        </div>
        <!--申请表正文-->
        <div class="applyDiv">
          <!--标题-->
          <div class="applyHead">
            <p class="applyHeadP">个人会员</p>
          </div>
          <!--基础资料-->
          <div class="applyBox">
            <p class="applyTitle">基本资料</p>
            <div class="applySpanBox">
              <p>手机号：</p>
              <p>验证码：</p>
              <p>姓名：</p>
              <p>密码：</p>
              <p>重复密码：</p>
              <p>性别：</p>
              <p>出生年月：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="applyFormText col-11 form-control" v-model="mobile" @input="sendmobile" :class='{ErrPrompt:ifErrPrompt}'>
              <p class='errP' v-show="ifErrPrompt">请输入正确的手机号</p>
              <input type="text" class="applyFormText col-6 form-control" style="float: left" v-model="code">
              <a href="#" class="applyFormA" :class="{disableA:ifdisableA}" @click="getVerification">{{codeTxt}}</a>
              <input type="text" class="applyFormText col-11 form-control" v-model="nickname">
              <input type="password" class="applyFormText col-11 form-control" v-model="password">
              <input type="password" class="applyFormText col-11 form-control" v-model="password_confirmation">
              <select class="applyFormText col-11 form-control" v-model="sex">
                <option value="1">男</option>
                <option value="2">女</option>
              </select>
              <el-date-picker v-model="born" type="date" class="data_form"></el-date-picker>
              <!--<input type="date" class="applyFormText col-11 form-control" v-model="born">-->
            </div>
          </div>
          <!--联系方式-->
          <div class="applyBox">
            <p class="applyTitle">联系方式</p>
            <div class="applySpanBox">
              <p>从事专业：</p>
              <p>工作单位：</p>
              <p>职务：</p>
              <p>职称：</p>
              <p>办公电话：</p>
              <p>通信地址：</p>
              <p>常用邮箱：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="applyFormText col-11 form-control" v-model="profession">
              <input type="text" class="applyFormText col-11 form-control" v-model="unit">
              <input type="text" class="applyFormText col-11 form-control" v-model="job">
              <input type="text" class="applyFormText col-11 form-control" v-model="post">
              <input type="text" class="applyFormText col-11 form-control" v-model="tel" @input="sendphone" :class='{ErrPrompt:ifErrPhone}'>
              <p class='errP' v-show="ifErrPhone">请输入正确的电话</p>
              <input type="text" class="applyFormText col-11 form-control" v-model="addr">
              <input type="text" class="applyFormText col-11 form-control" v-model="email">
            </div>
          </div>
          <!--详细资料-->
          <div class="applyBox">
            <p class="applyTitle">详细资料</p>
            <div class="applySpanBox">
              <p>学历：</p>
              <p>所学专业：</p>
              <p>毕业院校：</p>
              <p>政治面貌：</p>
            </div>
            <div class="applyFormBox form-group">
              <input type="text" class="applyFormText col-11 form-control" v-model="education">
              <input type="text" class="applyFormText col-11 form-control" v-model="major">
              <input type="text" class="applyFormText col-11 form-control" v-model="graduated">
              <select class="applyFormText col-11 form-control" v-model="outlook">
                <option v-for="(item, key) in outlooks" :key="key" :value="key">{{item}}</option>
              </select>
            </div>
          </div>
          <!--资料提交-->
          <div class="applyBox">
            <p class="applyTitle">资料提交</p>
            <div class="applySpanBox">
              <p style="margin-bottom: 41px">会员类型：</p>
              <p>申请报告：</p>
            </div>
            <div class="applyFormBox form-group" style="margin-left: 10px;margin-top: 10px">
              <span v-for="(item,index) in memberships" :key="index">
                <input name="memberType" type="radio" class="applyFormRadio" :value="index" v-model="membership">
                <label>{{item}}</label>
              </span>
              <form>
                <div class="fileBtnBox">
                  <img :src="uploadPresentation" v-show="uploadPresentation !== ''">
                  <img src="../assets/img/imguploadbtn.png" v-show="uploadPresentation === ''">
                  <input type="file" @change="getFile($event)" name="upload" class="imgUpload" id="img1">
                </div>
                <input type="hidden" name="from" value="upload">
                <input type="hidden" name="dir" value="images">
              </form>
              <a style="font-size: 13px;" class="explain" @click="personApplication">下载个人入会申请书模版，签名后拍照或扫描上传</a>
            </div>
          </div>
          <!--提交按钮-->
          <div class="applyBox">
            <div class="applyFormBox form-group">
              <input type="button" class="applyFormBtn btn" @click="personRegister" value="注册">
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemMember from '@/components/item/itemMember.vue'
import choiceApply from '@/components/apply/choiceApply.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'
import ChoiceApply from './apply/choiceApply'

export default {
  name: 'individualApply',
  data () {
    return {
      // 所在页面的名称
      topName: 'apply',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/apply',
      secondtest: '会员注册',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: [],
      // 用于正则判断的样式参数
      ifErrPrompt: false, // 手机
      ifErrPhone: false, // 电话
      // 图片上传后返回的图片路径
      uploadPresentation: '',
      // 政治面貌下拉选项
      outlooks: [],
      // 会员类型选项
      memberships: [],
      // 表单数据
      mobile: '', // 手机号
      code: '', // 验证码
      password: '', // 密码
      password_confirmation: '', // 确认密码
      group: '0', // 会员申请类型，个人是0，企业是1
      nickname: '', // 姓名
      sex: '', // 性别
      born: '2000-12-31', // 出生日期
      unit: '', // 工作单位
      tel: '', // 办公电话
      addr: '', // 同信地址
      email: '', // 邮箱
      education: '', // 学历
      major: '', // 所学专业
      graduated: '', // 毕业院校
      job: '', // 职务
      post: '', // 职称
      profession: '', // 从事专业
      outlook: '', // 政治面貌
      membership: '', // 会员类型
      report: '', // 申请报告的id
      // 图片提交参数
      file: '',
      // 获取验证按钮的文字
      codeTxt: '获取验证码',
      // 判断是否需要禁用二维码获取按钮
      ifdisableA: false,
      // 定时器
      timer: null
    }
  },
  components: {
    ChoiceApply,
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemMember: itemMember,
    choiceApply: choiceApply
  },
  methods: {
    // 获得验证码
    getVerification () {
      // 先验证下手机号是不是正确输入
      if (this.mobile === '') {
        this.$message.error('请输入手机号')
      } else if (this.ifErrPrompt === true) {
        this.$message.error('请输入正确的手机号')
      } else {
        HttpServer.post('http://api.gdics.cn/api/code', {
          mobile: this.mobile
        }).then(res => { /* 请求成功，http状态码为200 */
          if (res.code === 200) { // 发送成功
            // 返回成功提示
            this.$message.success(res.msg + '，60秒后可重新发送')
            // 禁用发送按钮
            this.codeTxt = '59 秒后重新发送'
            this.ifdisableA = true
            let a = 58
            this.timer = setInterval(() => {
              this.codeTxt = a + ' 秒后重新发送'
              a--
              if (a < 0) {
                clearInterval(this.timer)
                this.ifdisableA = false
                this.codeTxt = '获取验证码'
              }
            }, 1000)
          } else if (res.code === 403) { // 手机号已存在等其他不满足条件的情况
            this.$message.error(res.msg)
          } else { // res.code === 500 运营商错误
            this.$message.error('运营商服务器错误')
          }
        }).catch(err => { /* 请求失败 */
          if (err.code !== 200) {
            this.$message.error('运营商错误，请稍后再试')
          }
        })
      }
    },

    // 图片提交事件
    getFile (event) {
      event.preventDefault()
      // 获得文件值
      this.file = event.target.files[0]
      // 模拟form数据
      let formData = new FormData()
      formData.append('from', 'upload')
      formData.append('dir', 'images')
      formData.append('upload', this.file)
      // 定义请求头
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      // 调用接口
      this.$http.post('http://api.gdics.cn/api/imgupload', formData, config)
        // 请求成功
        .then(function (res) {
          if (res.body.code === 200) {
            this.uploadPresentation = res.body.data.path
            this.report = res.body.data.id
          } else {
            this.$message.error(res.body.msg + '，请不要超过2m')
          }
        })
        // 请求失败
        .catch(function (err) {
          this.$message.error('服务器出错')
          console.log(err)
        })
    },

    // 注册提交事件
    personRegister: function () {
      // 调用post请求接口
      HttpServer.post('http://api.gdics.cn/api/private_signup', {
        mobile: this.mobile,
        code: this.code,
        password: this.password,
        password_confirmation: this.password_confirmation,
        group: this.group,
        nickname: this.nickname,
        sex: this.sex,
        born: this.born,
        unit: this.unit,
        tel: this.tel,
        addr: this.addr,
        email: this.email,
        education: this.education,
        major: this.major,
        graduated: this.graduated,
        job: this.job,
        post: this.post,
        profession: this.profession,
        outlook: this.outlook,
        membership: this.membership,
        report: this.report
      }).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.msg)
        } else {
          this.$confirm('恭喜你注册成功', '注册成功', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.$router.push('/')
          }).catch(() => {
            this.$router.push('/')
          })
        }
      })
    },

    // 副导航栏渲染
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.member = res.member
        this.cate = res.cate
      })
    },

    // 手机正则验证
    sendmobile (event) {
      var reg = 11 && /^1[345678]\d{9}$/
      // 手机号为空
      if (event.target.value === '') {
        this.ifErrPrompt = true
      } else if (!reg.test(event.target.value)) { // 手机号不符合正则匹配
        this.ifErrPrompt = true
      } else { // 手机号正确
        this.ifErrPrompt = false
      }
    },

    // 电话正则验证
    sendphone (event) {
      if (event.target.value === '') {
        this.ifErrPhone = true
      } else if (event.target.value.length < 7) {
        this.ifErrPhone = true
      } else {
        this.ifErrPhone = false
      }
    },

    // 下载个人入会申请书模板
    personApplication: function () {
      HttpServer.get('http://api.gdics.cn/api/download_file').then(res => {
        window.location.href = res.msg[0].path
      })
    }
  },
  mounted () {
    // get请求，渲染下拉选项
    HttpServer.get('http://api.gdics.cn/api/signinfo').then(res => {
      this.outlooks = res.msg.outlook
      this.memberships = res.msg.personal
      console.log(this.memberships)
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .applyBody{
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
    text-align: right;
  }
  .applyTips{
    font-size: 12px;
    margin-bottom: 15px;
  }
  .applyTips a{
    color: #999999;
  }
  .applyDiv{
    width: 100%;
    border-radius: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #ffffff;
  }
  .applyHead{
    width: 100%;
    height: 50px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 30px;
  }
  .applyHeadP{
    margin-top: auto;
    margin-bottom: auto;
    line-height: 50px;
    font-size: 24px;
    background-color: #0064e6;
    font-family: '微软雅黑';
  }
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .applyBox{
    position: relative;
    width: 80%;
    background-color: #ffffff;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    overflow: hidden;
    border-bottom: 1px solid #e3e3e3;
  }
  .applyTitle{
    position: absolute;
    top: 8px;
    left: 20px;
    color:#007bff;
    font-weight: 600;
    font-family: '微软雅黑';
  }
  .applySpanBox{
    width: 40%;
    float: left;
    padding-top: 8px;
    padding-left: 200px;
  }
  .applyFormBox{
    width: 40%;
    float: right;
    margin-right: 150px;
  }
  .applySpanBox p{
    width: 100%;
    margin-bottom: 34px;
    float: right;
    color: #999999;
  }
  .applyFormText{
    margin-bottom: 20px;
  }
  .applyFormA{
    margin: 30px;
    line-height: 36px;
  }
  .applyFormLab{
    margin-left: 10px;
    font-size: 14px;
    color: #999999;
    font-family: '微软雅黑';
  }
  .applyFormBtn{
    width: 290px;
    color: #ffffff;
    background-color: #0064e6;
  }
  .applyFormRadio{
    margin-right: 10px;
    margin-left: 10px;
  }
  /* 文件选择标签 */
  .a-upload {
    padding: 4px 10px;
    height: 20px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    color: #888;
    background: #fafafa;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    *display: inline;
    *zoom: 1
  }
  .a-upload  input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
  }
  .a-upload:hover {
    color: #444;
    background: #eee;
    border-color: #ccc;
    text-decoration: none
  }
  .imgUpload{
    opacity: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .fileBtnBox{
    margin-top: 30px;
    width: 293px;
    height: 180px;
    border-radius: 4px;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    position: relative;
    cursor: pointer;
    overflow: hidden;
  }
  .fileBtnBox img{
    width: 100%;
  }
  /* 用于正则判断的样式 */
  .ErrPrompt{
    border: 1px #f56e6e solid;
    margin-bottom: 12px;
  }
  .errP{
    font-size: 12px;
    color: #f56e6e;
    margin-bottom: 10px;
    line-height: 0px;
  }
  .explain{
    font-size: 11px;
    cursor: pointer;
    color: #007bff !important;
  }
  /* 禁用获取验证码的按钮 */
  .disableA{
    pointer-events: none;
    color: #999999;
    font-size: 12px;
  }
  /*日期样式*/
  .data_form{
    width: 100%;
    min-width: 293px;
  }
</style>



// WEBPACK FOOTER //
// src/components/individualApply.vue